import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchCollectionWithPost } from '@app/src/api/fetchHooks'
import { useProvidersModal } from '@app/src/context/ProvidersModalContext'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { Response } from '@app/src/types/resourceExplorer'
import { useFlags } from 'launchdarkly-react-client-sdk'

interface useAlreadyExistingReportedDataProps {
  enabled: boolean
  templateIds: number[]
}

export const useAlreadyExistingReportedData = ({ enabled, templateIds }: useAlreadyExistingReportedDataProps) => {
  const { providersToConnect } = useProvidersModal()
  const { currentReportingPeriod } = useFlags()

  const {
    items: alreadyExistingReportedData,
    isLoading: alreadyExistingReportedDataLoading,
    isFetched: alreadyExistingReportedDataFetched,
  } = useFetchCollectionWithPost<Response>({
    key: FetchKey.Response,
    options: { enabled: enabled && templateIds.length > 0 },
    endpoint: endpoints.responsesCollection,
    payload: {
      filter: [
        {
          name: 'request.subscriptions.targetProviderId',
          filters: [{ value: providersToConnect.map(o => o.id), operator: Operators.In }],
        },
        {
          name: 'request.questionnaireTemplateId',
          filters: [{ value: templateIds, operator: Operators.In }],
        },
        {
          name: 'isScraped',
          filters: [{ value: false, operator: Operators.EqualTo }],
        },
        {
          name: 'request.periodName',
          filters: [{ value: currentReportingPeriod.toString(), operator: Operators.EqualTo }],
        },
      ],
      include: ['request.subscriptions.target'],
    },
  })

  return { alreadyExistingReportedData, alreadyExistingReportedDataLoading, alreadyExistingReportedDataFetched }
}
